import { BountyClaim, BountyIntroContact } from '@foodfluence/shared';

export type IntroFieldKey = 'name' | 'role' | 'email' | 'phone' | 'instagramHandle' | 'note';

export type IntroFormValues = {
  name: string;
  role: string;
  email: string;
  phone: string;
  instagramHandle: string;
  note: string;
};

export function claimToIntroFormValues(claim: Pick<BountyClaim, 'contact' | 'note'>): IntroFormValues {
  const contact = claim.contact;
  return {
    name: contact?.name ?? '',
    role: contact?.role ?? '',
    email: contact?.email ?? '',
    phone: contact?.phone ?? '',
    instagramHandle: contact?.instagramHandle ? `@${contact.instagramHandle.replace(/^@+/, '')}` : '',
    note: claim.note ?? '',
  };
}

export function hasIntroContactMethod(values: IntroFormValues): boolean {
  return Boolean(values.email.trim() || values.phone.trim() || values.instagramHandle.trim());
}

export function validateIntroForm(values: IntroFormValues): Partial<Record<IntroFieldKey, string>> {
  const next: Partial<Record<IntroFieldKey, string>> = {};
  if (!values.name.trim()) next.name = 'Contact name is required';
  if (!values.role.trim()) next.role = 'Role / title is required';
  if (!hasIntroContactMethod(values)) {
    next.email = 'Provide at least one: email, phone, or Instagram handle';
  }
  return next;
}

export function introFormToContact(values: IntroFormValues): BountyIntroContact {
  return {
    name: values.name.trim(),
    role: values.role.trim(),
    ...(values.email.trim() ? { email: values.email.trim() } : {}),
    ...(values.phone.trim() ? { phone: values.phone.trim() } : {}),
    ...(values.instagramHandle.trim()
      ? { instagramHandle: values.instagramHandle.trim().replace(/^@+/, '') }
      : {}),
  };
}

export const INTRO_CHANNEL_LABELS = {
  email: 'Email',
  sms: 'Text message',
  whatsapp: 'WhatsApp',
  dm: 'Instagram DM',
} as const;

export function formatIntroContactSummary(contact: BountyIntroContact): string {
  const parts = [
    contact.email,
    contact.phone,
    contact.instagramHandle ? `@${contact.instagramHandle.replace(/^@+/, '')}` : undefined,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(' · ') : '—';
}
